<template>
  <section
    v-if="about"
    class="relative section-bg-home text-white"
    :style="{ backgroundImage: `url(${bgImage})` }"
  >
    <ThirdSectionSvg class="absolute top-0 left-0 right-0" />
    <div class="bg-transparent"></div>

    <div>
      <div class="relative py-16 px-4 lg:py-24">
        <div class=" max-w-screen-xl lg:flex lg:items-center">
          <div class="mb-12 lg:mb-0 lg:w-1/3">
            <div class="lg:w-2/3 lg:mx-auto">
              <h3 class="text-5xl font-bold">{{ about.title }}</h3>
            </div>
          </div>

          <div
            class="text-lg max-w-2xl mx-auto lg:max-w-none lg:w-2/3 lg:px-12 lg:text-left"
          >
            <p>
              {{ about.text }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import ThirdSectionSvg from '@/components/HomeThirdSectionSvg'

export default {
  components: { ThirdSectionSvg },

  computed: {
    ...mapState('home', ['mainContent', 'about']),

    bgImage() {
      if (this.mainContent.bg_image_url) {
        return this.mainContent.bg_image_url
      }

      return '/img/home-background.jpg'
    },
  },
}
</script>

<style scoped>
section {
  background-image: url('../assets/img/home-background.jpg');
}

.bg-transparent {
  @apply absolute inset-0 w-full h-full;
  background: rgba(0, 0, 0, 0.5);
}
</style>
